import React, { createContext, useState } from 'react';

import { Tutorial } from '../../containers/tutorial';

export const TutorialContext = createContext({
  tutorialEnabled: null,
  setTutorialEnabled: () => {},
  initialStep: null,
  setInitialStep: () => {},
});

const TutorialProvider = ({ children }) => {
  const [tutorialEnabled, setTutorialEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(1);

  const value = {
    tutorialEnabled,
    setTutorialEnabled,
    initialStep,
    setInitialStep,
  };

  const handleExit = () => {
    setTutorialEnabled(false);
    setInitialStep(1);
  };

  return (
    <TutorialContext.Provider value={value}>
      <Tutorial
        enabled={tutorialEnabled}
        scenario={1}
        initialStep={initialStep}
        onExit={handleExit}
        onBeforeChange={(curStep) => setInitialStep(curStep + 1)}
        onAfterChange={(curStep, element, config) => {
          if (typeof config.onAfterChange === 'function') {
            config.onAfterChange();
          }
        }}
      />
      {children}
    </TutorialContext.Provider>
  );
};

export default TutorialProvider;
